module.exports = __webpack_public_path__ + "img/guanwang_sudi_02.369ed64d.png";